// extracted by mini-css-extract-plugin
export var container = "_f3-0";
export var infoIcon = "_f3-2";
export var titleRowCol = "_f3-1";